import React from 'react';
import * as DatesUtils from '../../utils/dates';
import { Languages, AuthRoles } from '../../config';

const CONFIGURATION = {};

export default CONFIGURATION;

// export const TableColumns = [
//   {
//     label: '#',
//     id: 'notification_id',
//     render: (rowIndex: number, cellValue: any, columnIndex: number) => (
//       <React.Fragment>{cellValue}</React.Fragment>
//     ),
//     inData: true,
//   },
//   {
//     label: 'VAT Number',
//     id: 'vat_num',
//     render: (rowIndex: number, cellValue: any, columnIndex: number) => (
//       <React.Fragment>{cellValue}</React.Fragment>
//     ),
//     inData: true,
//   },

//   {
//     label: 'Type',
//     id: 'notification_type',
//     render: (rowIndex: number, cellValue: any, columnIndex: number) => (
//       <React.Fragment>{cellValue}</React.Fragment>
//     ),
//     inData: true,
//   },

//   {
//     label: 'Title',
//     id: 'notification_title',
//     render: (rowIndex: number, cellValue: any, columnIndex: number) => (
//       <React.Fragment>{cellValue}</React.Fragment>
//     ),
//     inData: true,
//   },

//   {
//     label: 'Message',
//     id: 'notification_message',
//     render: (rowIndex: number, cellValue: any, columnIndex: number) => (
//       <React.Fragment>{cellValue}</React.Fragment>
//     ),
//     inData: true,
//   },
//   {
//     label: 'Seen',
//     id: 'is_read',
//     render: (rowIndex: number, cellValue: any, columnIndex: number) => (
//       <React.Fragment>{cellValue ? 'Yes' : 'No'}</React.Fragment>
//     ),
//     inData: true,
//   },
//   // {
//   //   label: 'Actions',
//   //   align: 'center',
//   //   id: 'action1',
//   //   render: (
//   //     rowIndex: number,
//   //     cellValue: any,
//   //     columnIndex: number,
//   //     data: any
//   //   ) => (
//   //     <ActionsBlock
//   //       rowIndex={rowIndex}
//   //       data={data}
//   //       dataid={data[rowIndex].notification_id}
//   //     />
//   //   ),
//   //   inData: false,
//   // },
// ];

// interface ITableDefaultFetchValues {
//   TABLE_DEFAULT_PAGE: number;
//   TABLE_DEFAULT_PAGE_SIZE: number;
//   TABLE_DEFAULT_ORDER: 'desc' | 'asc';
//   TABLE_DEFAULT_SORT_KEY: string;
// }

// export const TableDefaultFetchValues: ITableDefaultFetchValues = {
//   TABLE_DEFAULT_PAGE: 0,
//   TABLE_DEFAULT_PAGE_SIZE: 10,
//   TABLE_DEFAULT_ORDER: 'desc',
//   TABLE_DEFAULT_SORT_KEY: TableColumns[0].id,
// };

export const Translations = {
  page_title: {
    [Languages.Greek]: 'Reimbursements',
    [Languages.English]: 'Reimbursements',
  },
  title: {
    [Languages.Greek]: 'Reimbursements Received',
    [Languages.English]: 'Reimbursements Received',
  },
  description: {
    [Languages.Greek]:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec blandit gravida ligula, a molestie ligula blandit vel. Aenean urna turpis, pellentesque sit amet egestas eu, viverra et ligula. Vestibulum rhoncus arcu augue, eu semper dui pellentesque non.',
    [Languages.English]:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec blandit gravida ligula, a molestie ligula blandit vel. Aenean urna turpis, pellentesque sit amet egestas eu, viverra et ligula. Vestibulum rhoncus arcu augue, eu semper dui pellentesque non.',
  },
  go_to_dashboard: {
    [Languages.Greek]: 'Go to dasbhoard',
    [Languages.English]: 'Go to dasbhoard',
  },
  vat_number: {
    [Languages.Greek]: 'VAT Number',
    [Languages.English]: 'VAT Number',
  },
  originatingCountry: {
    [Languages.Greek]: 'Originating Country',
    [Languages.English]: 'Originating Country',
  },
  schemeType: {
    [Languages.Greek]: 'Scheme Type',
    [Languages.English]: 'Scheme Type',
  },
  state: {
    [Languages.Greek]: 'State',
    [Languages.English]: 'State',
  },
  search: {
    [Languages.Greek]: 'Search',
    [Languages.English]: 'Search',
  },
  clear: {
    [Languages.Greek]: 'Clear',
    [Languages.English]: 'Clear',
  },
};
